import { render, staticRenderFns } from "./Admin.Detail.vue?vue&type=template&id=2809dce4&"
import script from "./Admin.Detail.vue?vue&type=script&lang=js&"
export * from "./Admin.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports